<div class="page-header">
  <app-prev-next-button (click)="navigateToMap()" direction="left" label="Voltar ao armazém"></app-prev-next-button>
  <h1>Escaninho</h1>
</div>
<div *ngIf="this.fullLoaderService.isOpen$ | async">
  <app-full-page-loader></app-full-page-loader>
</div>
<div class="page-content">
  <div class="left-side">
    <app-pigeonhole-occupation-info [id]="id"></app-pigeonhole-occupation-info>
    <app-position-info-card [position]="positionInfo"></app-position-info-card>
    <app-pigeonhole-misplaced [id]="id"></app-pigeonhole-misplaced>
  </div>
  <div class="right-side" [class.blurred]="(fullLoaderService.isOpen$ | async)">
    <app-side-color-card color="primary-1">
      <app-pigeonhole-map-position-view [id]="id" 
        [mapMode]="'pigeonhole'"
        content
        #mapComponent
        (mapLoaded)="mapLoaded()"
        (toggleTipEvent)="openTip = $event" 
        (triggerLoader)="showLoader($event)" 
        [openTip]="openTip"
        [map]="map"
        [positionInfo]="positionInfo">
      </app-pigeonhole-map-position-view>
    </app-side-color-card>
  </div>
</div>

<ng-template #notification>
  <app-notification [data]="notificationData" icon="times-circle"></app-notification>
</ng-template>
